import { AppBar, Typography, Box, IconButton, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";

import { useSelector } from "react-redux";
import NewKuikwitLogo from "src/assets/images/auth/NewLogoImage.png";
import KuikwitLogoOnly from "src/assets/images/auth/kuikwit_logo.png";
import getHeaderText from "src/utils/layout/useGetHeaderText";
import { useTour } from "src/context/global/TourContext";
import Notification from "./notification";
import ProfileBox from "./profileBox";
import useStyles from "./Styles";
import GlobalAvailabilityToggle from "./GlobalAvailabilityToggle";

const Header = () => {
  const { classes } = useStyles();

  const { drawer } = useSelector((state: any) => state.drawer);
  const {
    startDashboardTour,
    startReportsTour,
    startChatScreenTour,
    startUserManagementTour,
    startSettingsTour,
  } = useTour();
  const navigate = useNavigate();

  const location = useLocation();

  const { heading, text } = getHeaderText(location.pathname);

  // Dynamic Tooltip Text
  const getTooltipText = () => {
    if (location.pathname === "/reports") return "Reports Guide";
    if (location.pathname === "/chats") return "Chats Guide";
    if (location.pathname === "/users") return "Users Guide";
    if (location.pathname.includes("/settings")) return "Settings Guide";
    return "Dashboard Guide";
  };

  return (
    <AppBar position="static" className={classes.root}>
      <Box className={classes.appBarInnerMainBox}>
        <Box
          className={classes.appBarLogoBox}
          sx={{
            minWidth: drawer ? "220px" : "70px",
          }}
        >
          {/* Full Logo */}
          <img
            src={NewKuikwitLogo}
            alt="Kuikwit full logo"
            className={`${classes.logoImage} ${
              drawer ? classes.logoVisibleDelayed : classes.logoHidden
            }`}
            style={{ width: "170px", height: "40px", position: "absolute" }}
          />

          {/* Icon-only Logo */}
          <img
            src={KuikwitLogoOnly}
            alt="Kuikwit icon logo"
            className={`${classes.logoImage} ${
              !drawer ? classes.logoVisible : classes.logoHidden
            }`}
            style={{ width: "50px", height: "40px", position: "absolute" }}
          />
        </Box>
        <Box className={classes.appBarContentBox}>
          <Box className={classes.headBox}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography className={classes.heading}>{heading}</Typography>
              <Tooltip title={getTooltipText()}>
                <IconButton
                  color="inherit"
                  onClick={() => {
                    if (location.pathname === "/reports") {
                      startReportsTour();
                    } else if (location.pathname === "/chats") {
                      startChatScreenTour();
                    } else if (location.pathname === "/users") {
                      startUserManagementTour();
                    } else if (location.pathname.includes("/settings")) {
                      startSettingsTour();
                    } else if (location.pathname !== "/") {
                      navigate("/");

                      // Small timeout to allow navigation to complete before starting tour
                      setTimeout(() => startDashboardTour(), 500);
                    } else {
                      startDashboardTour();
                    }
                  }}
                >
                  <MenuBookOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Box>
            <Typography className={classes.subtext}>{text}</Typography>
          </Box>
          <Box className={classes.appBarRightContent}>
            <GlobalAvailabilityToggle />
            <Notification />
            <ProfileBox />
          </Box>
        </Box>
      </Box>
    </AppBar>
  );
};

export default Header;
